<template>
  <div>
    <z-centralized-toolbar>
      <v-toolbar-items>
        <v-btn text small color="primary" @click="adicionar">
          <v-icon left>mdi-bank-plus</v-icon>
          Adicionar
        </v-btn>
        <v-btn text @click="refresh" :loading="$store.state.loading">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-toolbar-items>

      <z-text-field-search v-model="busca" select class="ml-5" @keydown.enter="buscar" @click:clear="limparBusca" />
    </z-centralized-toolbar>

    <v-divider />

    <z-scroll-layout :top-position="$v.TOP_POSITION">
      <z-container>
        <z-cabecalho>{{ $store.state.titulo_tela }}</z-cabecalho>

        <v-card>
          <v-data-table
            mobile-breakpoint="0"
            :options.sync="paginacao"
            :server-items-length="total_itens"
            :footer-props="$v.FOOTER_PROPS"
            :headers="headers"
            :items="contas"
            item-key="id"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.nome }}</td>
                <td>{{ descricaoTipo(item) }}</td>
                <td>
                  <v-chip v-if="item.padrao" x-small color="primary" outlined>Padrão</v-chip>
                </td>
                <td class="text-right">{{ item.saldo_inicial | valorBR }}</td>
                <td>{{ item.ativo ? 'Sim' : 'Não' }}</td>
                <td class="text-center">
                  <v-btn icon @click="editar(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                  <v-btn icon @click="tornarPadrao(item)" :disabled="item.padrao || definindoPadraoId === item.id" :loading="definindoPadraoId === item.id">
                    <v-icon>mdi-check-circle</v-icon>
                  </v-btn>
                  <v-btn icon @click="perguntarExcluir(item)"><v-icon>mdi-delete</v-icon></v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </z-container>
    </z-scroll-layout>

    <v-form v-model="form_valido" lazy-validation ref="formulario">
      <z-dialogo ref="dialogoAdicionar" largura="800px" titulo="Conta Financeira" dividers persistent @abrir="$refs.formulario.resetValidation()">
        <template v-slot:conteudo>
          <v-row dense>
            <v-col cols="12" sm="6">
              <z-text-field v-model="conta.nome" label="Nome" placeholder=" " :rules="[regras.campoObrigatorio]" />
            </v-col>
            <v-col cols="12" sm="3">
              <z-select
                v-model="conta.tipo"
                :items="tiposConta"
                item-value="value"
                item-text="text"
                label="Tipo"
                outlined
                dense
                hide-details="auto"
                :rules="[regras.campoObrigatorio]"
              />
            </v-col>
            <v-col cols="12" sm="3">
              <z-campo-valor v-model="conta.saldo_inicial" label="Saldo inicial" placeholder=" " />
            </v-col>
            <v-col cols="12" sm="12">
              <z-textarea v-model="conta.observacao" label="Observação" placeholder=" " rows="2" />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="2" class="d-flex align-center">
              <v-switch class="my-0" hide-details  v-model="conta.ativo" label="Ativo" />
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions_right>
          <v-btn text @click="$refs.dialogoAdicionar.fechar()" :disabled="salvando">Cancelar</v-btn>
          <v-btn color="primary" @click="confirmar" :loading="salvando" :disabled="!form_valido">Confirmar</v-btn>
        </template>
      </z-dialogo>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import * as regras from '@/app/helpers/validacoes';

export default {
  name: 'ContasFinanceirasLista',
  inject: ['notifications'],
  data() {
    return {
      headers: [
        { text: 'Nome', value: 'nome' },
        { text: 'Tipo', value: 'tipo', width: '160px' },
        { text: 'Padrão', value: 'padrao', width: '120px', sortable: false },
        { text: 'Saldo inicial', value: 'saldo_inicial', width: '160px', align: 'right' },
        { text: 'Ativo', value: 'ativo', width: '120px' },
        { text: 'Opções', value: '', width: '200px', align: 'center', sortable: false },
      ],
      salvando: false,
      definindoPadraoId: null,
      form_valido: true,
      regras: { ...regras },
      tiposConta: [
        { text: 'Dinheiro', value: 'dinheiro' },
        { text: 'Conta Corrente', value: 'conta_corrente' },
        { text: 'Poupança', value: 'poupanca' },
        { text: 'Investimentos', value: 'investimentos' },
        { text: 'Outros', value: 'outros' },
      ],
    };
  },
  computed: {
    ...mapState('contasfinanceiras', ['conta', 'contas', 'total_itens']),
    busca: {
      get() {
        return this.$store.state.contasfinanceiras.busca;
      },
      set(value) {
        this.$store.commit('contasfinanceiras/SET_BUSCA', value);
      },
    },
    paginacao: {
      get() {
        return this.$store.state.contasfinanceiras.paginacao;
      },
      set(value) {
        this.$store.commit('contasfinanceiras/UPDATE_PAGINACAO', value);
      },
    },
  },
  created() {
    this.refresh();
  },
  mounted() {
    this.setTitulo('Financeiro - Contas Financeiras');
  },
  methods: {
    ...mapMutations(['setTitulo']),
    ...mapActions('contasfinanceiras', ['listar', 'abrir', 'salvar', 'atualizar', 'excluir']),
    async refresh() {
      await this.listar();
    },
    buscar() {
      this.$store.commit('contasfinanceiras/SET_PAGE', 1);
      this.refresh();
    },
    limparBusca() {
      this.busca = '';
      this.buscar();
    },
    adicionar() {
      this.$store.commit('contasfinanceiras/ZERAR');
      this.$refs.dialogoAdicionar.abrir();
    },
    async editar(item) {
      await this.abrir(item.id);
      this.$refs.dialogoAdicionar.abrir();
    },
    async tornarPadrao(item) {
      if (item.padrao) {
        return;
      }

      try {
        this.definindoPadraoId = item.id;
        await this.abrir(item.id);
        await this.atualizar({ ...this.conta, padrao: true });
        this.notifications.notificar('Conta financeira definida como padrão.');
        await this.refresh();
      } catch (error) {
        this.notifications.notificarErro('Não foi possível definir a conta financeira padrão.', error);
      } finally {
        this.definindoPadraoId = null;
      }
    },
    descricaoTipo(item) {
      if (item?.tipo_descricao) {
        return item.tipo_descricao;
      }

      const tipo = this.tiposConta.find((tipoConta) => tipoConta.value === item?.tipo);
      return tipo?.text || item?.tipo || '';
    },
    async confirmar() {
      if (!this.$refs.formulario.validate()) {
        return;
      }

      try {
        this.salvando = true;
        if (this.conta.id) {
          await this.atualizar(this.conta);
        } else {
          await this.salvar(this.conta);
        }
        this.$refs.dialogoAdicionar.fechar();
        this.notifications.notificar('Conta financeira salva com sucesso.');
        await this.refresh();
      } catch (error) {
        this.notifications.notificarErro('Não foi possível salvar a conta financeira.', error);
      } finally {
        this.salvando = false;
      }
    },
    async perguntarExcluir(item) {
      const resposta = await this.notifications.dialogo_pergunta.abrir({
        titulo: 'Remover Conta Financeira?',
        texto: 'A conta financeira será removida do sistema.',
        botoes: ['Cancelar', 'Remover'],
        padrao: 'Remover',
        cor: 'red',
      });

      if (resposta === 'Remover') {
        this.notifications.dialogo_pergunta.carregando();
        await this.excluir(item.id);
        this.notifications.dialogo_pergunta.fechar();
        this.notifications.notificar('Conta financeira excluída com sucesso.');
      } else {
        this.notifications.dialogo_pergunta.fechar();
      }
    },
  },
  watch: {
    paginacao: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>
